import { StepIds } from '~/components/premarketplace/partner-config';
import { CustomerFormValues } from '~/types/marketplace';

type ParentEventType = 'view' | 'track';
type EventActionType = 'opened' | 'closed' | 'next' | 'back' | 'submitted' | 'skipped';

type ParentEventPayload = {
  stepName?: StepIds;
  action?: EventActionType;
  payload?: Record<string, string | string[] | number | boolean | null> | Partial<CustomerFormValues>;
};

const getOrigin = (value: string | undefined | null) => {
  if (!value) return null;

  try {
    return new URL(value).origin;
  } catch {
    return null;
  }
};

const getParentOrigin = () => {
  const ancestorOrigins = (window.location as Location & { ancestorOrigins?: DOMStringList }).ancestorOrigins;
  const ancestorOrigin = ancestorOrigins?.length ? ancestorOrigins[0] : null;

  return getOrigin(ancestorOrigin) ?? getOrigin(document.referrer);
};

// Any well-formed parent origin is accepted here: this app is embedded on arbitrary partner
// domains (see PREMARKETPLACE.md). The real security boundary is on the receiving side —
// embed.js validates event.origin against its own BASE_URL before acting on a message — so the
// sender does not need to allowlist origins itself. Callers are still responsible for keeping
// customer-identifying fields out of the payload, since any embedding parent can receive it.
export const sendParentEvent = (type: ParentEventType, payload?: ParentEventPayload) => {
  const targetOrigin = getParentOrigin();

  // 'null' is the literal origin string for opaque origins (e.g. a sandboxed iframe or
  // about:blank) and isn't a valid postMessage targetOrigin.
  if (!targetOrigin || targetOrigin === 'null') return;

  window.parent.postMessage({ type, payload: JSON.stringify(payload ?? null) }, targetOrigin);
};
